import { render, staticRenderFns } from "./IndagineEpidemiologicaBotulismoEditComponent.vue?vue&type=template&id=6391746c"
import script from "./IndagineEpidemiologicaBotulismoEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaBotulismoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports